import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const Countdown = ({ countdownDate }) => {
  const { t } = useTranslation()

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTime())
    }, 1000)
    return () => clearTimeout(timer)
  })

  // safari needs the date to be in the format of MM/DD/YYYY hh:mm
  const formatDate = (date) => {
    const fullDate = date?.split(' ')[0]
    const time = date?.split(' ')[1]
    const formatted = fullDate?.split('-')
    const year = formatted && formatted[0]
    const month = formatted && formatted[1]
    const day = formatted && formatted[2]
    return new Date(`${month}/${day}/${year} ${time}`)
  }

  const calculateTime = () => {
    const difference = formatDate(countdownDate) - new Date()
    let timeLeft = {}
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }
    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTime())

  return (
    <>
      {timeLeft.days ||
        timeLeft.hours ||
        (timeLeft.minutes && (
          <div className="countdown">
            <div className="countdown-row">
              <div className="countdown-time">
                <span className="countdown-time-value">
                  {timeLeft.days ? timeLeft.days : '0'}
                </span>
                <span className="countdown-time-unit">
                  {t('countdown.days')}
                </span>
              </div>
              <div className="countdown-time">
                <span className="countdown-time-value">
                  {timeLeft.hours ? timeLeft.hours : '0'}
                </span>
                <span className="countdown-time-unit">
                  {t('countdown.hours')}
                </span>
              </div>
              <div className="countdown-time">
                <span className="countdown-time-value">
                  {timeLeft.minutes ? timeLeft.minutes : '0'}
                </span>
                <span className="countdown-time-unit">
                  {t('countdown.minutes')}
                </span>
              </div>
            </div>
          </div>
        ))}
    </>
  )
}

export default Countdown
